function loadEmbedSocialScript() {
  const id = "EmbedSocialHashtagScript";

  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.src = "https://embedsocial.com/cdn/ht.js";
  script.async = true;

  document.head.appendChild(script);
}

function initGoogleReviewsLazyLoad() {
  let loaded = false;

  const loadScript = () => {
    if (loaded) return;
    loaded = true;

    setTimeout(() => {
      loadEmbedSocialScript();
    }, 3000);

    removeListeners();
  };

  const removeListeners = () => {
    window.removeEventListener("scroll", loadScript);
    window.removeEventListener("mousemove", loadScript);
    window.removeEventListener("touchstart", loadScript);
    window.removeEventListener("click", loadScript);
  };

  window.addEventListener("scroll", loadScript, { once: true, passive: true });
  window.addEventListener("mousemove", loadScript, { once: true, passive: true });
  window.addEventListener("touchstart", loadScript, { once: true, passive: true });
  window.addEventListener("click", loadScript, { once: true, passive: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGoogleReviewsLazyLoad);
} else {
  initGoogleReviewsLazyLoad();
}